import ContactUsForm from 'components/ContactUsForm';
import { CONTACT_ID_FROM_LANDING_PAGE } from 'containers/LandingPage/FarmToTablePage/saga';
import React, { FC, Fragment, useCallback } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { compose, Dispatch } from 'redux';
import { createStructuredSelector } from 'reselect';
import translations from 'translations';
import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';
import { checkEmailSubmit, contactUsSubmit } from './actions';
import messages from './messages';
import reducer from './reducer';
import saga from './saga';
import selectContactUsPage from './selectors';
import { ContactUsPageState, ContactUsForm as IContactUsForm, RootState } from './types';

type ContactUsFormParams = IContactUsForm & { contactId?: string; odooCustomerId?: number };

interface IDispatchProps {
  onCheckEmail: (email: string) => void;
  onSubmit: (data: ContactUsFormParams) => void;
}

interface IStateProps {
  contactuspage: ContactUsPageState;
}

type Props = IStateProps & IDispatchProps & RouteComponentProps;

const ContactUsPage: FC<Props> = (props) => {
  const { contactuspage, onCheckEmail, onSubmit, ...rest } = props;
  const { isCheckingEmail, validationEmailMessage, isSuccess, submitting } = contactuspage;
  // const [campaignSource, , removeCampaignSource] = useSessionStorage<BranchLinkSearch>(
  //   SessionStorageKey.CAMPAIGN_SOURCE,
  // );
  const query = rest?.history.location && (new URLSearchParams(rest?.history?.location?.search) as any);
  const onSubmitContactUs = useCallback(
    (data: ContactUsFormParams) => {
      data.businessCategory = '';
      data.businessType = '';
      if (!data.email) {
        data.email = '';
      }
      onSubmit({
        ...data,
        contactId: query.get('contactId') || window.localStorage.getItem(CONTACT_ID_FROM_LANDING_PAGE) || undefined,
        odooCustomerId: query.get('odooCustomerId') ? Number(query.get('odooCustomerId')) : undefined,
      });
      if (window?.clarity) {
        window.clarity('set', 'sign_up', '1');
      }
      // if (!!campaignSource) {
      //   removeCampaignSource();
      // }
    },
    [onSubmit],
  );

  return (
    <Fragment>
      <Helmet>
        <title>{`${translations(messages.header)} | Nhà Cung Cấp Kamereo`}</title>
        <meta name="description" content={`${translations(messages.header)}`} />
        <meta property="og:title" content={`${translations(messages.header)}`} />
        <meta name="og:description" content={`${translations(messages.header)}`} />
      </Helmet>
      <ContactUsForm
        isSuccess={isSuccess}
        submitting={submitting}
        onSubmit={onSubmitContactUs}
        onCheckEmail={onCheckEmail}
        isCheckingEmail={isCheckingEmail}
        validationEmailMessage={validationEmailMessage}
        {...rest}
      />
    </Fragment>
  );
};

const mapStateToProps = createStructuredSelector<RootState, IStateProps>({
  contactuspage: selectContactUsPage(),
});

const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
  onSubmit: (values: ContactUsFormParams) => dispatch(contactUsSubmit(values)),
  onCheckEmail: (email: string) => dispatch(checkEmailSubmit(email)),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

const withReducer = injectReducer<ContactUsPageState>({ key: 'contactUsPage', reducer: reducer });

const withSaga = injectSaga<ContactUsPageState>({ key: 'contactUsPage', saga: saga });

export default compose(withReducer, withSaga, withConnect, withRouter)(ContactUsPage);
